import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const useAlertStore = defineStore('alertStore', () => {
  const content = ref([])

  const alertModalRef = ref(null);
  const confirmModalRef = ref(null);

  function register(modal) {
    alertModalRef.value = modal
  }

  function registerConfirmModal(modal) {
    confirmModalRef.value = modal
  }

  async function $alert(messageOrList, buttonText) {
    content.value = Array.isArray(messageOrList)
      ? messageOrList.map(String)
      : [String(messageOrList)]
    if (!alertModalRef.value) {
      console.warn('AlertModal not registered yet')
      return Promise.resolve(true)
    }
    return alertModalRef.value.show(buttonText || '') // 기존 AlertModal의 show() Promise 그대로 반환
  }

  async function $confirm(messageOrList, okButtonText, cancelButtonText) {
     content.value = Array.isArray(messageOrList)
      ? messageOrList.map(String)
      : [String(messageOrList)]
    if (!confirmModalRef.value) {
      console.warn('ConfirmModal not registered yet')
      return Promise.resolve(true)
    }
    return confirmModalRef.value.show(okButtonText || '', cancelButtonText || '') // 기존 ConfirmModal의 show() Promise 그대로 반환
  }

  return { content, register, $alert, $confirm, registerConfirmModal }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAlertStore, import.meta.hot))
}